exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".CarSelectorBrandLogo {\n  border-radius: 50%;\n  vertical-align: middle;\n  margin-right: 10px; }\n\n#CarSelectorModel .flex-section {\n  margin-bottom: 0; }\n", ""]);

// exports
